import { AuditLogDateRangeFilter } from "./filters/AuditLogDateRangeFilter";

export const SectionFiltersAndSearch = () => {
  return (
    <div className="mt-2 mb-5 flex items-center gap-3">
      <div className="flex grow items-center gap-[15px]">
        <AuditLogDateRangeFilter />
      </div>
    </div>
  );
};
